import TEC_PROFILES from "./tecProfiles";

export default value => {
    const profile = TEC_PROFILES.find((i) => i.value === value);

    return profile ? profile.text : false;
}